import { useQuery } from 'react-query';

//APP
import { api } from '../../../api';
import { localConfig } from '../../../../Configs/localConfig';
import { errorAlert } from '../../../../utils/alert';


//#region INSUMOS DEFENSIVOS

//TYPES
type typeInsumosDefensivos = {
    cod: number,
    cod_conta: number,
    cod_cliente: number,
    cod_categoria_produto: number,
    cod_fabricante: number,
    nome: string,
    descricao: string,
    cod_formulacao: number,
    adjuvante: number,
    cod_tipo_adjuvante: number,
    observacao: string,
    cod_medida_aplicacao: number,
    cod_classe_agronomica: number,
    cod_fertilizante: number,
    cod_tecnologia: number,
    acao_ph_calda: number,
    cod_fornecedor: number,
    tipo_formulacao: string,
    tipo_aditivo: string,
    fabricante_nome: string,
    categoria_produto_nome: string,
    classe_agronomica_nome: string,
    nome_medida_aplicacao: string,
    fornecedor_nome: string,
    composicao: {
        cod: number,
        cod_ativo: number,
        ativo_nome: string,
        cod_produto: number,
        cod_replica: number,
        concentracao: number,
        produto_nome: string,
        cod_tipo_medida: number,
        nome_tipo_medida: string,
        ativo: {
            cod: number,
            nome: string,
            cod_grupo: number,
            grupo_nome: string,
            cod_modo_acao: number,
            cod_local_acao: number,
            modo_acao_nome: string,
            local_acao_nome: string,
            cod_grupo_quimico: number,
            cod_classe_quimica: number,
            cod_mecanismo_acao: number,
            grupo_quimico_nome: string,
            classe_quimica_nome: string,
            mecanismo_acao_nome: string,
            local_mecanismo_acao: string,
            cod_categoria_produto: number,
            cod_classe_agronomica: number,
            classe_agronomica_nome: string
        }[]
    }[],
    fertilizante: [],
    aplicacoes: {
        cod: number,
        cod_produto: number,
        cod_cultura: number,
        cod_fase_cultura: number,
        dose: number,
        plant_back: number,
        cod_replica: number,
        produto_nome: string,
        cultura_nome: string,
        fase_cultura_nome: string
    }[]
}

//INTERFACE
export interface InsumosDefensivos {
    itens: typeInsumosDefensivos[],
    total: number
}

export interface UseGetInsumosDefensivosParams {
    codCategoriaProduto: number;
    pagination: number;
    page: number;
    busca?: string;
}

export const useGetInsumosDefensivos = ({
    codCategoriaProduto,
    pagination,
    page,
    busca
}: UseGetInsumosDefensivosParams) => {

    let { conta } = localConfig();

    const queryKey: any = ['insumos_defensivos', codCategoriaProduto, pagination, page, busca];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<InsumosDefensivos, Error>(queryKey, async () => {
        return api.get(`/recomendacao/insumo-agricola?pagination=${pagination}&codConta=${conta}&embed=composicao,aplicacoes&page=${page}&codCategoriaProduto=${codCategoriaProduto}${busca ? `&nomeGeral=${busca}` : ''}`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de insumos!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 180000, //3 minutos
            keepPreviousData: true,
        }
    );

    return {
        data_insumos_defensivos: data?.itens,
        total_insumos_defensivos: data?.total,
        carregando_insumos_defensivos: isFetching,
        refetch_data_insumos_defensivos: refetch,
        isFetched_insumos_defensivos: isFetchedAfterMount,
        isError_insumos_defensivos: isError
    };
};
//#endregion

//#region Categoria produtos
//TYPES
type typeCategoriaProdutos = {
    cod: number,
    nome: string,
    cod_grupo: number,
    cod_categoria: number | null,
    cod_categoria_produto: number | null,
    principal: boolean,
    grupo_categoria_produto_nome: string,
    categoria_nome: string | null,
    categoria_principal_nome: string | null
}

//INTERFACE
export interface CategoriaProdutos {
    itens: typeCategoriaProdutos[]
}

export const useGetCategoriaProdutos = (codGrupo: number) => {

    const queryKey: any = ['categoria_produtos', codGrupo];

    const { data, isFetching, refetch } = useQuery<CategoriaProdutos, Error>(queryKey, async () => {
        return api.get(`/categoria-produto?codGrupo=${codGrupo}&pagination=-1`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de categorias!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 300000, //5 minutos
            keepPreviousData: true,
        }
    );

    return {
        data_categoria_produtos: data?.itens,
        carregando_categoria_produtos: isFetching,
        refetch_categoria_produtos: refetch,
    };
};
//#endregion